// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".h-selected-course[data-v-e3163554]{margin:0 0 30px}", "",{"version":3,"sources":["webpack://./templates/general_questions/course_doesnt_have_book/CourseDoesntHaveBook.vue"],"names":[],"mappings":"AACA,oCACC,eAAD","sourcesContent":["\n.h-selected-course {\n\tmargin: 0 0 30px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
